import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_420: DocMigration = {
  maxSchemaVersion: "0.0.420",
  description: "Split up ROOF_OVERHANG_ANNOS and ROOF_DORMER_ANNOS categories to enable proper styling",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      if (viewTemplate.viewType !== "PLAN_VIEW") {
        continue;
      }
      viewTemplate.categories = replaceSheetGeometryCategories(viewTemplate.categories);
    }

    for (const effectId in json.effects) {
      const effect = json.effects[effectId];
      // effects only apply to the plan view type at the moment
      effect.categories = replaceSheetGeometryCategories(effect.categories);
    }
    return json;
  },
};

function replaceSheetGeometryCategories(categories: string[]) {
  const newCategories: string[] = [];

  const hasCategoryBeenReplaced: { [cat: string]: true } = {};

  for (const category of categories) {
    // ensure that any duplicate categories are ignored
    if (hasCategoryBeenReplaced[category]) {
      continue;
    }

    hasCategoryBeenReplaced[category] = true;

    const replacementCategories = categoryReplaceMap[category];
    if (replacementCategories) {
      newCategories.push(...replacementCategories);
    } else {
      newCategories.push(category);
    }
  }

  return newCategories;
}

const categoryReplaceMap: Record<string, string[]> = {
  ROOF_OVERHANG_ANNOS: [
    "ROOF_OVERHANG_DIM_LABEL",
    "ROOF_OVERHANG_DIM_LINEWORK",
    "ROOF_OVERHANG_DIM_TICK",
    "ROOF_OVERHANG_DIM_WITNESS",
  ],
  ROOF_DORMER_ANNOS: [
    "ROOF_DORMER_OVERHANG_DIM_LABEL",
    "ROOF_DORMER_OVERHANG_DIM_LINEWORK",
    "ROOF_DORMER_OVERHANG_DIM_TICK",
    "ROOF_DORMER_OVERHANG_DIM_WITNESS",
    "ROOF_DORMER_FRAMING",
  ],
};

export default migration_0_0_420;
